
import { useState } from 'react';

import { useNavigate } from "react-router";

import { Grid, Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Typography, TextField, Alert, List, ListItem, ListItemText, Box, IconButton, Chip, Stack } from "@mui/material";

import UndoIcon from '@mui/icons-material/Undo';
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import moment from "moment";

import { Layout } from "../../components/Layout"
import { BoxAdministrarDocumentos } from '../../components/BoxAdministrarDocumentos';

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { BuscarDocumento, CancelarDocumento } from "../../connections/admin/AdministrarDocumentosConnection";

import { BitacoraDocumentosProps, BuscarDocumentoProps } from "../../interfaces/admin/AdministracionDocumentosInterface";

const defaultDocumento : BuscarDocumentoProps = { id: '', folio: '', numeroSeguimiento: '', urlDescarga: '', idEstatus: 0, estatus: '', bitacoraDocumentos: [], };

type ErrorType = 'success' | 'warning' | 'error';

interface Errors {
    type?:          ErrorType;
    descripcion?:   string;
}

export const AdministracionDocumentosPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState( false );
    const [loadingCancelarDocumento, setLoadingCancelarDocumento] = useState( false );

    const [documento, setDocumento] = useState<BuscarDocumentoProps>( defaultDocumento );
    const [bitacoraDocumentos, setBitacoraDocumentos] = useState<BitacoraDocumentosProps[]>( [] );

    const [filtroAplicado, setFiltroAplicado] = useState( false );    
    const [documentoCancelado, setDocumentoCancelado] = useState( false );    

    const [numeroSeguimiento, setNumeroSeguimiento] = useState( '' );
    const [messageBox, setMessageBox] = useState( '' );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );   

    const [url, setUrl] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );   
    const [fullScreen, setFullScreen] = useState( false );

    const [errors, setErrors] = useState<Errors>({ });

    const handleBuscar = async () => {

        setErrors( {} );
        setLoading( true );
        setFiltroAplicado( true );

        await BuscarDocumento({ numeroSeguimiento }).then( resp => {

            const { success, message, bitacoraDocumentos } = resp;    

            if( success ){

                setTimeout(() => {

                    setDocumento( resp );
                    setLoading( false );
                    setBitacoraDocumentos( bitacoraDocumentos );
                    
                }, 700);

            }
            else{

                setTimeout(() => {
                
                    setMessageBox( message );
                    setLoading( false );
                    setBitacoraDocumentos( bitacoraDocumentos );

                }, 700);
                
            }    

        });

    }

    const handleClear = () => {

        setErrors( {} );
        setFiltroAplicado( false ); 
        setNumeroSeguimiento( '' );
        setDocumento( defaultDocumento );
        setBitacoraDocumentos( [] );
    }

    const handleCancelarDocumento = async () => {

        setLoadingCancelarDocumento( true );

        await CancelarDocumento({ numeroSeguimiento: documento.numeroSeguimiento, id: documento.id, }).then( resp => {           

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    setLoadingCancelarDocumento( false );
                    setOpenConfirmacion( false );

                    setDocumentoCancelado( true );
                    setMessageBox( message );

                    handleClear();
                    
                }, 700);

            }
            else{

                setTimeout(() => {

                    setLoadingCancelarDocumento( false );
                    setOpenConfirmacion( false );

                    setErrors({ type: 'error', descripcion: message });
                    
                }, 700);

            }         

        });

    }

    return (
        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Admnistración de documentos' } ]} backgroundPaper={false}>
            
            <Grid container spacing={3} >  
                                        
                <Grid size={{ md: 12, xs: 12 }} textAlign={'start'}>

                    <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid> 

                <Grid size={{ md: 4, xs: 12 }}>

                    <Grid container spacing={3}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <Card>

                                <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Filtro(s) </Typography> }/>

                                <Divider />

                                <CardContent sx={{ p: 3 }}> 

                                    <Grid container spacing={3} mt={1}>

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Número de seguimiento"
                                                placeholder='RT-1'
                                                variant="outlined"
                                                value={ numeroSeguimiento }
                                                onChange={ (e) => setNumeroSeguimiento( e.target.value.toUpperCase() ) }
                                                disabled={ filtroAplicado }
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}       
                                            /> 

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }} textAlign={'end'}>

                                            <Button 
                                                fullWidth
                                                color={ filtroAplicado ? 'secondary' : 'primary' }  
                                                variant={ filtroAplicado ? 'outlined' : 'contained' }    
                                                onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }                      
                                                disabled={ numeroSeguimiento === '' || loading }
                                                loading={ loading }
                                            > 
                                                { filtroAplicado ? 'limpiar filtro' : 'Buscar'}
                                            </Button> 

                                        </Grid>

                                        {
                                            errors.descripcion
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>
                                                    <Alert icon={ <InfoOutlineIcon /> } variant='filled' severity={ errors.type }>                                              
                                                        { errors.descripcion }
                                                    </Alert>
                                                </Grid>
                                        }

                                    </Grid>    

                                </CardContent>    

                            </Card>

                        </Grid>
                        
                        <Grid size={{ md: 12, xs: 12 }}>

                            <Card>

                                <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Bitácora </Typography> }/>

                                <Divider />

                                <CardContent sx={{ p: 3 }}> 

                                    <List disablePadding sx={{ height: 300, overflowY: bitacoraDocumentos.length > 1 ? 'scroll' : 'hidden', pr: 1 }}>
 
                                        {
                                            bitacoraDocumentos
                                            .map( ( { idFirmaElectronica, folio, urlDescarga, fecha, fechaCancelacion }, index ) => (
                                               
                                                <Card
                                                    key={index}
                                                    variant="outlined"
                                                    sx={{
                                                        mb: 2,
                                                        borderRadius: 2,
                                                    }}
                                                >
                                              
                                                    <CardHeader
                                                        title={
                                                            <Typography variant="subtitle1" fontWeight={700}>
                                                                Folio #{folio}
                                                            </Typography>
                                                        }
                                                        subheader={
                                                            <Typography variant="subtitle2" color="text.secondary" fontSize={14}>
                                                               (ID {idFirmaElectronica})
                                                            </Typography>
                                                        }
                                                        action={
                                                            <IconButton
                                                                onClick={() => {
                                                                setUrl(urlDescarga);
                                                                setOpenDocumento(true);
                                                                }}
                                                            >
                                                                <FileOpenOutlinedIcon />
                                                            </IconButton>
                                                        }
                                                    />

                                                    <CardContent>

                                                        <Grid container spacing={3}>

                                                            <Grid size={{ md: 6, xs: 12 }}>

                                                                <Stack spacing={0.5}>

                                                                    <Typography variant="subtitle2" color="text.secondary" fontSize={12}>
                                                                        Fecha del documento:
                                                                    </Typography>

                                                                    <Typography variant="subtitle2" fontWeight={500}>
                                                                        { moment(fecha).format( "DD-MM-YYYY hh:mm a" ) }
                                                                    </Typography>

                                                                </Stack>

                                                            </Grid>

                                                            <Grid size={{ md: 6, xs: 12 }}>

                                                                <Stack spacing={0.5}>

                                                                    <Typography variant="subtitle2" color="text.secondary" fontSize={12}>
                                                                        Fecha de cancelación:
                                                                    </Typography>

                                                                    <Typography variant="subtitle2" fontWeight={500}>
                                                                        { moment(fechaCancelacion).format("DD-MM-YYYY hh:mm a") }
                                                                    </Typography>

                                                                </Stack>

                                                            </Grid>

                                                        </Grid>

                                                    </CardContent>

                                                </Card>

                                            ))
                                        }

                                        {
                                            ( bitacoraDocumentos.length === 0 && filtroAplicado && !loading )
                                            &&
                                                <ListItem alignItems="center" sx={{ textAlign: 'center', height: 250 }}>
                                                    <ListItemText primary={ <Typography variant="caption" color='secondary'> No se encontraron registros </Typography> } />
                                                </ListItem>
                                        }
                                    
                                        {
                                            ( bitacoraDocumentos.length === 0 && !filtroAplicado && !loading )
                                            &&
                                                <ListItem alignItems="center" sx={{ textAlign: 'center', height: 250 }}>
                                                    <ListItemText primary={ <Typography variant="caption" color='secondary'> Busque por número de seguimiento, <br /> para visualizar la bitácora</Typography> } />
                                                </ListItem>
                                        }

                                    </List>
                          
                                </CardContent>    

                            </Card>

                        </Grid>

                    </Grid>

                </Grid> 

                <Grid size={{ md: 8, xs: 12 }}>
                
                    <Card>

                        <CardHeader 
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }} 
                            subheader={                                   

                                <Grid container spacing={3}>

                                    <Grid size={6}>
                                        <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del documento </Typography>
                                    </Grid>
                                    
                                    <Grid size={6}>
                                
                                        {
                                            ( documento.idEstatus !== 0 && documento.idEstatus !== 8 && documento.idEstatus !== 9 && documento.idEstatus !== 10 )
                                            &&
                                                <Box textAlign={'end'}>                                                       

                                                    <Button               
                                                        size='small'                             
                                                        color='error'
                                                        variant='contained'
                                                        onClick={ () => setOpenConfirmacion( true ) }                                            
                                                    >
                                                        Cancelar documento
                                                    </Button>

                                                </Box> 
                                        }
                                    </Grid>

                                </Grid>

                            }                        
                        />

                        <Divider />

                        <CardContent sx={{ height: 530, p: 3 }}> 

                            <Grid container spacing={3}>   

                                {
                                    documento.id !== ''
                                    &&
                                        <>

                                            <Grid size={{ md: 3, xs: 12 }}>                

                                                <Grid container>

                                                    <Grid size={{ md: 12, xs: 12 }}>
                                               
                                                        <List disablePadding>
                        
                                                            <ListItem sx={{ py: 1, px: 0 }}>
                        
                                                                <ListItemText
                                                                    sx={{ mr: 2 }}
                                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de seguimiento: </Typography> }
                                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { documento.numeroSeguimiento } </Typography> }
                                                                />
                        
                                                            </ListItem>
                        
                                                            <ListItem sx={{ py: 1, px: 0 }}>
                        
                                                                <ListItemText
                                                                    sx={{ mr: 2 }}
                                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Folio del documento: </Typography> }
                                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { documento.folio } </Typography> }
                                                                />
                        
                                                            </ListItem>
                                                            
                                                            {
                                                                documento.fecha
                                                                &&
                                                                    <ListItem sx={{ py: 1, px: 0 }}>
                        
                                                                        <ListItemText
                                                                            sx={{ mr: 2 }}
                                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha del documento: </Typography> }
                                                                            secondary={ 
                                                                                <Typography variant='subtitle2' fontWeight={'bold'}> 
                                                                                    { 
                                                                                        moment( documento.fecha ).format("DD-MM-YYYY hh:mm a")
                                                                                    } 
                                                                                </Typography> 
                                                                            }
                                                                        />
                        
                                                                    </ListItem>
                                                            }    
                                                            
                                                            <ListItem sx={{ py: 1, px: 0 }}>
                        
                                                                <ListItemText
                                                                    sx={{ mr: 2 }}
                                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Estatus: </Typography> }
                                                                    secondary={ 
                                                                        <Chip 
                                                                            variant='filled'
                                                                            sx={{ fontWeight: 'bold', mt: 1 }}
                                                                            color={ documento.idEstatus === 9 ? 'primary' : documento.idEstatus === 10 ? 'warning' : 'default' }
                                                                            label={ 
                                                                                <Typography variant='subtitle1' fontWeight={'600'} fontSize={14}> 
                                                                                    { documento.estatus }
                                                                                </Typography> 
                                                                            }
                                                                        />
                                                                    }
                                                                />
                        
                                                            </ListItem>                                                              
                        
                                                        </List>                        

                                                    </Grid>
                                                  
                                                </Grid>  
                                                    
                                            </Grid>

                                            <Grid size={{ md: 9, xs: 12 }}>                                            
                                                                
                                                <iframe 
                                                    title='iframe  Demanda o Escrito Inicial'
                                                    style={{ width: '100%', height: '480px' }} 
                                                    src={ documento.urlDescarga }                                
                                                />                                                

                                            </Grid>     
                                            
                                            <Grid size={{ md: 12, xs: 12 }} textAlign={'center'}>
                                                <Typography variant='subtitle2' fontWeight={'bold'}> { documento.urlDescarga } </Typography>
                                            </Grid>

                                        </>                                    
                                }   

                                {
                                    ( ( documento.id === '' && filtroAplicado && !loading ) || ( documento.id === '' && documentoCancelado ) )
                                    &&
                                        <BoxAdministrarDocumentos 
                                            message={ messageBox } 
                                        />
                                }

                                {
                                    ( documento.id === '' && !filtroAplicado && !loading )
                                    && 
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                width={'100%'}
                                                height={500}
                                            >
                                                <Typography variant="caption" color='secondary'> Busque por número de seguimiento, para visualizar el documento</Typography>                                                 
                                            </Box>

                                        </Grid>
                                }

                            </Grid>                                    

                        </CardContent>    

                    </Card>

                </Grid>

            </Grid> 

            <Dialog 
                maxWidth='sm'    
                fullWidth={true}
                disableEscapeKeyDown
                open={ openConfirmacion } 
                onClose={ () => {} } 
            >
                
                <DialogTitle>
                    Confirmación
                </DialogTitle>
                
                <DialogContent sx={ DialogContentStyle }>
                
                    <DialogContentText>
                        ¿Desea cancelar la firma electrónica de este documento?
                    </DialogContentText>
                
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loadingCancelarDocumento } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button onClick={ handleCancelarDocumento } variant='contained' loading={ loadingCancelarDocumento }> Aceptar </Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                maxWidth="md"
                fullWidth={ true } 
                open={ openDocumento } 
                fullScreen={ fullScreen } 
                onClose={ () => {} } 
            >       

                <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, textAlign: 'end' }}>
                
                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setFullScreen( (prev) => !prev ) }>
                        { fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon /> } 
                    </IconButton>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setOpenDocumento( false ) }>
                        <CloseIcon />
                    </IconButton>
                
                </DialogTitle>        
                
                <DialogContent sx={{ p: 0 }}>
                    
                    <Grid container spacing={3} height={'100%'} >                                                
                    
                        <Grid size={{ md: 12, xs: 12}} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
    
                            {
                                documento
                                ?
                                    <iframe title='Documento' src={ url } height={ fullScreen ? "100%" : '500px' } width="100%" style={{ border: 'none' }}></iframe>
                                :
                                    <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                        No se encontró el documento
                                    </Typography>                          
                            }

                        </Grid>
                        
                    </Grid>
                    
                </DialogContent> 

            </Dialog>  

        </Layout>
    )
}
